import {NgModule} from '@angular/core';
import {PipeModule} from '../pipes/pipe.module';
import {MaintenanceModule} from '../modules/maintenance/maintenance.module';
import { SettingsMenuBtnModule } from '../components/settings-menu-btn/settings-menu-btn.module';
import { SettingsMenuModule } from '../components/settings-menu/settings-menu.module';
import { BuilderModule } from '../modules/builder/builder.module';
import { HomeModule } from '../modules/home/home.module';
import { GetStartedModule } from '../modules/get-started/get-started.module';
import { OauthConnectModule } from '../modules/oauth-connect/oauth-connect.module';
import { HeaderModule } from '../components/header/header.module';
import { BackdropModule } from '../components/backdrop/backdrop.module';
import { GetStartedFormModule } from '../components/get-started-form/get-started-form.module';
import { GetStartedFixedModule } from '../components/get-started-fixed/get-started-fixed.module';
import { SearchMenuModule } from '../components/search-menu/search-menu.module';
import { SuggestionsModule } from '../components/suggestions/suggestions.module';
import { SuggestionNotifyFloatModule } from '../components/suggestion-notify-float/suggestion-notify-float.module';
import { EditDialogModule } from '../components/edit-dialog/edit-dialog.module';
import { RegisterDialogModule } from '../components/register-dialog/register-dialog.module';
import { SaveDialogModule } from '../components/save-dialog/save-dialog.module';
import { UserSaveSendDialogModule } from '../components/user-save-send-dialog/user-save-send-dialog.module';
import { FooterMarketingModule } from '../components/footer-marketing/footer-marketing.module';
import { SentToEmailModule } from '../modules/sent-to-email/sent-to-email.module';
import { SavedToXrefModule } from '../modules/saved-to-xref/saved-to-xref.module';
import { BlogPostsModule } from '../components/blog-posts/blog-posts.module';


@NgModule({
  imports: [
    PipeModule,
    MaintenanceModule,
    SettingsMenuBtnModule,
    SettingsMenuModule,
    BuilderModule,
    HomeModule,
    GetStartedModule,
    OauthConnectModule,
    SettingsMenuModule,
    HeaderModule,
    BackdropModule,
    GetStartedFormModule,
    GetStartedFixedModule,
    SearchMenuModule,
    SuggestionsModule,
    SuggestionNotifyFloatModule,
    EditDialogModule,
    RegisterDialogModule,
    SaveDialogModule,
    UserSaveSendDialogModule,
    FooterMarketingModule,
    SentToEmailModule,
    SavedToXrefModule,
    BlogPostsModule
  ],
  exports: [
    PipeModule,
    MaintenanceModule,
    SettingsMenuBtnModule,
    SettingsMenuModule,
    BuilderModule,
    HomeModule,
    GetStartedModule,
    OauthConnectModule,
    SettingsMenuModule,
    HeaderModule,
    BackdropModule,
    GetStartedFormModule,
    GetStartedFixedModule,
    SearchMenuModule,
    SuggestionsModule,
    SuggestionNotifyFloatModule,
    EditDialogModule,
    RegisterDialogModule,
    SaveDialogModule,
    UserSaveSendDialogModule,
    FooterMarketingModule,
    SentToEmailModule,
    SavedToXrefModule,
    BlogPostsModule
  ]
})
export class SharedModule {}
